
const TermsOfUsePopup= () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
    <h1 className="text-3xl font-bold mb-6">아이옵스 스페이스 이용약관</h1>
    
    <nav className="mb-8">
      <h2 className="text-xl font-semibold mb-4">목차</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li><a href="#purpose" className="text-blue-600 hover:underline">제 1조 [목적]</a></li>
        <li><a href="#definitions" className="text-blue-600 hover:underline">제 2조 [정의]</a></li>
        <li><a href="#terms-posting" className="text-blue-600 hover:underline">제 3조 [약관의 게시와 개정]</a></li>
        <li><a href="#other-rules" className="text-blue-600 hover:underline">제 4조 [약관 외 준칙]</a></li>
        <li><a href="#5" className="text-blue-600 hover:underline">제 5조 [이용계약 체결]</a></li>
        <li><a href="#6" className="text-blue-600 hover:underline">제 6조 [회원정보의 변경]</a></li>
        <li><a href="#7" className="text-blue-600 hover:underline">제 7조 [개인정보보호 의무]</a></li>
        <li><a href="#8" className="text-blue-600 hover:underline">제 8조 [회원의 아이디 및 비밀번호의 관리에 대한 의무]</a></li>
        <li><a href="#9" className="text-blue-600 hover:underline">제 9조 [회원에 대한 통지]</a></li>
        <li><a href="#10" className="text-blue-600 hover:underline">제 10조 [회사의 의무]</a></li>
        <li><a href="#11" className="text-blue-600 hover:underline">제 11조 [회원의 의무]</a></li>
        <li><a href="#12" className="text-blue-600 hover:underline">제 12조 [서비스의 제공]</a></li>
        <li><a href="#13" className="text-blue-600 hover:underline">제 13조 [서비스의 변경 및 중단]</a></li>
        <li><a href="#14" className="text-blue-600 hover:underline">제 14조 [서비스 유료/무료 서비스의 제공 및 이용]</a></li>
        <li><a href="#15" className="text-blue-600 hover:underline">제 15조 [유료 서비스 이용계약의 청약철회 및 해지]</a></li>
        <li><a href="#16" className="text-blue-600 hover:underline">제 16조 [정보 제공 및 광고 게재]</a></li>
        <li><a href="#17" className="text-blue-600 hover:underline">제 17조 [게시물의 저작권]</a></li>
        <li><a href="#18" className="text-blue-600 hover:underline">제 18조 [게시물의 관리]</a></li>
        <li><a href="#19" className="text-blue-600 hover:underline">제 19조 [권리의 귀속]</a></li>
        <li><a href="#20" className="text-blue-600 hover:underline">제 20조 [회원의 지위 승계]</a></li>
        <li><a href="#21" className="text-blue-600 hover:underline">제 21조 [이용계약 해지 등]</a></li>
        <li><a href="#22" className="text-blue-600 hover:underline">제 22조 [이용제한 등]</a></li>
        <li><a href="#23" className="text-blue-600 hover:underline">제 23조 [손해배상]</a></li>
        <li><a href="#24" className="text-blue-600 hover:underline">제 24조 [책임제한]</a></li>
        <li><a href="#25" className="text-blue-600 hover:underline">제 25조 [해외이용]</a></li>
        <li><a href="#26" className="text-blue-600 hover:underline">제 26조 [준거법 및 재판관할]</a></li>
        <li><a href="#Addendum" className="text-blue-600 hover:underline">부칙</a></li>
      </ul>
    </nav>

    <section id="purpose" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 1조 [목적]</h2>
      <p>
        이 약관은 주식회사 아이옵스(이하 &quot;회사&quot;)가 제공하는 아이옵스 스페이스 및 관련 제반 서비스(이하 서비스)의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>
    </section>

    <section id="definitions" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 2조 [정의]</h2>
      <span>1. 이 약관에서 사용하는 용어의 정의는 아래와 같습니다.</span>
      <ol className="pl-5 space-y-2">
        <li>① &quot;서비스&quot;란 구현되는 단말기(각종 유무선 장치를 포함)와 상관없이 회원이 이용할 수 있는 아이옵스스페이스 및 관련 제반 서비스를 말합니다.</li>
        <li>② &quot;이용자&quot;란 서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
        <li>③ &quot;아이디&quot;란 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 회사가 승인하여 회사에 등록된 영문, 숫자, 영문과 숫자의 조합, 또는 이메일을 말합니다.</li>
        <li>④ &quot;비밀번호&quot;란 회원의 아이디와 일치되는 회원임을 확인하고 비밀보호를 위하여 회원 스스로가 설정한 문자 또는 문자와 숫자의 조합을 말합니다.</li>
        <li>⑤ &quot;교신프로필&quot;이란 교신할 지상국 스펙 정보를 확인하고, 궤도계산에 사용할 교신 정보를 등록하는 양식을 말합니다.</li>
        <li>⑥ &quot;스케쥴링&quot;이란 위성과 지상국의 교신을 위해 스케줄을 검색, 계산, 조회, 예약 등을 수행하는 것을 말합니다.</li>
        <li>⑦ &quot;게시물&quot;이란 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호∙문자∙음성∙음향∙화상∙동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 말합니다.</li>
        <li>⑧ &quot;콘텐츠&quot;란 게시물을 포함하여, 서비스상에 게재된 각종 사진, 일러스트, 템플릿, 아이콘, 편집디자인 소스 등을 말합니다.</li>
      </ol>
      <span>2. 제1항에서 정의되지 않은 용어의 의미는 관련법령 및 일반적인 거래관행을 따릅니다.</span>
    </section>

    <section id="terms-posting" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 3조 [약관의 게시와 개정]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 화면에 게시합니다.</li>
        <li>회사는 &quot;약관의 규제에 관한 법률&quot;, &quot;정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하&quot; 정보통신망법&quot;)&quot; 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
        <li>회사는 약관을 개정할 경우 그 개정이유 및 적용일자를 명시하여 현행 약관과 함께 적용일자 7일전부터 적용일 전일까지 제1항의 방법으로 공지합니다. 다만, 회원의 권리 또는 의무에 관한 중요한 규정의 변경은 최소한 30일전에 공지하고 공지 외에 회원이 등록한 이메일(e-mail), 서비스 접속시 동의 팝업창 등의 전자적 수단을 통해 따로 명확히 통지합니다.</li>
        <li>회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 개정약관 시행일 7일 후까지 거부의사를 표시하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 공지 또는 통지하며, 그럼에도 회원이 명시적으로 거부의 의사표시를 하지 않은 경우 회원이 개정약관에 동의한 것으로 봅니다.</li>
        <li>회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.</li>
      </ol>
    </section>

    <section id="other-rules" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 4조 [약관 외 준칙]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 &quot;기타 약관 등&quot;)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 &quot;기타 약관 등&quot;이 우선하여 적용됩니다.</li>
        <li>이 약관에서 정하지 아니한 사항이나 해석에 대해서는 &quot;기타 약관 등&quot; 및 관계법령 또는 상관례에 따릅니다.</li>
      </ol>
    </section>

    <section id="5" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 5조 [이용계약 체결]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 제5조에 따른 이용신청을 한 이용자에 대하여 업무 수행상 또는 기술상 지장이 없는 경우에 원칙적으로 접수 순서에 따라 서비스 이용을 승낙합니다.</li>
        <li>회사는 다음 각 호의 어느 하나에 해당하는 경우, 이용신청의 승낙을 하지 아니하거나, 해당 사유가 해소될 때까지 그 승낙을 유보할 수 있습니다.</li>
          <p>① 가입신청자가 이 약관 또는 서비스 운영정책에 의하여 회원자격을 상실한 경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함.</p>
          <p>② 타인의 명의를 이용하거나 신청양식을 허위로 기재한 경우</p>
          <p>③ 신청양식의 기재사항을 누락한 경우</p>
          <p>④ 14세 미만 아동인 경우 </p>
          <p>⑤ 가입신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</p>
          <p>⑥ 기타 회사에서 규정한 제반사항을 위반하며 신청한 경우</p>
        <li>제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</li>
        <li>회사는 서비스관련 설비가 부족하거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.</li>
        <li>제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 가입신청자에게 알리도록 합니다.</li>
        <li>이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.</li>
        <li>회사는 회원에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.</li>
        <li>회사는 회원에 대하여 &quot;영화 및 비디오물의 진흥에 관한 법률&quot; 및 &quot;청소년보호법&quot;등에 따른 등급 및 연령 준수를 위해 이용제한이나 등급별 제한을 할 수 있습니다.</li>
      </ol>
    </section>

    <section id="6" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 6조 [회원정보의 변경]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 서비스 이용과 관련하여 아이디 및 비밀번호를 포함하는 본인의 계정정보에 대한 관리의 책임이 있습니다. 따라서, 회원이 이를 소홀히 하여 발생하는 서비스 이용상의 손해 또는 제3자에 의한 부정 이용 등에 대한 책임은 회원에게 있으며, 회사는 이에 대하여 어떠한 책임도 부담하지 않습니다.</li>
        <li>회사는 회원의 계정정보를 회원 식별 수단으로 하여 당해 회원의 서비스 이용 가능 여부 등 회원 관리와 관련된 제반 업무를 수행합니다.</li>
        <li>회원은 회원정보 설정 화면을 통해서 본인의 개인정보를 열람하고 수정할 수 있습니다(회사명, 이름, 국가, 비밀번호). 다만 서비스 관리를 위해 필요한 아이디(이메일) 등은 수정이 불가하거나 수정 횟수 제한 등이 있을 수 있습니다.</li>
        <li>회사는 회원 아이디의 내용이 반사회적이거나, 미풍양속을 해치거나, 운영자로 오인할 우려가 있는 등의 경우에는 해당 아이디의 사용을 승낙하지 않거나 제한할 수 있습니다.</li>
        <li>회사는 보안 등을 이유로 회원에게 정기적 또는 비정기적으로 비밀번호의 변경을 권고할 수 있으며, 그 외의 경우에도 회원은 서비스상에서 비밀번호를 언제든지 변경할 수 있습니다.</li>
        <li>회원은 개인정보가 변경되었을 경우 즉시 이를 수정해야 하며, 수정하지 않음으로 인해 발생한 불이익에 대해서는 회사가 책임지지 않습니다.</li>
      </ol>
    </section>

    <section id="7" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 7조 [개인정보보호 의무]</h2>
      <p>
        회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다.
      </p>
    </section>

    <section id="8" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 8조 [회원의 아이디 및 비밀번호의 관리에 대한 의무]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원의 아이디와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안됩니다.</li>
        <li>회원은 아이디, 비밀번호 및 추가정보 등이 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 비밀 번호를 변경하여야 하며, 해당 사실을 회사에 통지하고 회사의 안내에 따라야 합니다.</li>
        <li>제2항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.</li>
      </ol>
    </section>

    <section id="9" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 9조 [회원에 대한 통지]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사가 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 회원이 지정한 이메일 등으로 통지할 수 있습니다.</li>
        <li>회사는 회원 전체에 대한 통지의 경우 7일 이상 서비스 내 공지사항 화면에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</li>
      </ol>
    </section>

    <section id="10" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 10조 [회사의 의무]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.</li>
        <li>회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.</li>
        <li>회사는 서비스이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 신속하게 처리하여야 합니다. 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 서비스 화면에 게재하거나 이메일 등을 통하여 회원에게 통지합니다.</li>
        <li>회사는 유료서비스 제공 시 유료서비스의 내용, 이용방법, 이용료, 결제방법 등을 명확히 공지해야 합니다.</li>
        <li>회사의 고의나 중과실에 의해 회원에게 손해가 발생한 경우 회사에서 책임을 부담하며, 그 책임의 범위는 통상 손해에 한합니다.</li>
      </ol>
    </section>

    <section id="11" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 11조 [회원의 의무]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 다음 행위를 하여서는 안 됩니다.</li>
          <p>① 회원가입신청 또는 변경 시 허위내용을 등록하는 행위</p>
          <p>② 회사의 서비스에 게시된 정보를 변경하거나 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 영리 또는 비영리의 목적으로 복제, 출판, 방송 등에 사용하거나 제3자에게 제공하는 행위</p>
          <p>③ 회사가 제공하는 서비스를 이용하여 제3자에게 본인을 홍보할 기회를 제공하거나 제3자의 홍보를 대행하는 등의 방법으로 금전을 수수하거나 서비스를 이용할 권리를 양도하고 이를 대가로 금전을 수수하는 행위</p>
          <p>④ 회사 기타 제3자에 대한 허위의 사실을 게재하거나 지적재산권을 침해하는 등 회사나 제3자의 권리를 침해하는 행위 </p>
          <p>⑤ 다른 회원의 아이디 및 비밀번호를 도용하여 부당하게 서비스를 이용하는 행위</p>
          <p>⑥ 타인의 계좌번호 및 신용카드번호 등 타인의 허락 없이 타인의 결제정보를 이용하여 회사의 유료서비스를 이용하는 행위</p>
          <p>⑦ 스팸(spam), 행운의 편지(chain letters), 피라미드 조직에 가입할 것을 권유, 외설 또는 폭력적인 메시지•화상•음성 등 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</p>
          <p>⑧ 정보통신망법 등 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 등)를 전송하거나 게시하는 행위</p>
          <p>⑨ 청소년보호법에서 규정하는 청소년유해매체물을 게시하는 행위</p>
          <p>⑩ 공공질서 또는 미풍양속에 위배되는 내용의 정보, 문장, 도형, 음성 등을 유포하는 행위</p>
          <p>⑪ 회사의 직원이나 서비스의 관리자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 이메일을 발송하는 행위</p>
          <p>⑫ 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 이메일로 발송하는 행위</p>
          <p>⑬ 스토킹(stalking), 욕설, 도배 등 다른 회원의 서비스 이용을 방해하는 행위</p>
          <p>⑭ 다른 회원의 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위</p>
          <p>⑮ 불특정 다수의 회원을 대상으로 하여 광고 또는 선전을 게시하거나 스팸을 전송할 목적으로 회사에서 제공하는 쪽지 기타 서비스를 이용하여 영리활동을 하는 행위</p>
          <p>⑯ 회사가 제공하는 소프트웨어 등을 개작하거나 리버스 엔지니어링, 디컴파일, 디스어셈블 하는 행위</p>
          <p>⑰ 현행 법령, 회사가 제공하는 서비스에 정한 약관 기타 서비스 이용에 관한 규정을 위반하는 행위</p>
        <li>회사는 회원이 제1항의 행위를 하는 경우 해당 게시물 등을 삭제 또는 임시 삭제할 수 있고 서비스의 이용을 제한하거나 일방적으로 본 계약을 해지할 수 있으며, 그 책임은 전적으로 회원이 부담하여야 합니다. </li>
        <li>회원은 관계법, 이 약관의 규정, 서비스 이용 정책, 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
      </ol>
    </section>

    <section id="12" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 12조 [서비스의 제공]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 회원에게 아래와 같은 서비스를 제공합니다.</li>
          <p>① 이용하고자 하는 교신 프로필을 입력한 후, 교신하고자 하는 스케줄을 조회 및 예약하고 회사가 사용(활용) 할 수 있는 안테나를 통해 실제 교신하여 관련 데이터를 취득하는 서비스</p>
          <p>② 기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</p>
        <li>회원은 이용계약 체결이 완료되면 바로 서비스 이용이 가능합니다. 다만, 유료 서비스의 경우 회사가 요금납입을 확인한 이후부터 가능하게 할 수 있습니다. </li>
        <li>이용계약 종료 후 데이터에 대한 회사의 보관기간은 30일입니다. 위 보관기간이 경과한 이후 회사는 해당 데이터에 대한 보관의무를 지지 않습니다.</li>
        <li>회사는 서비스를 일정 범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만 이러한 경우에는 그 내용을 사전에 공지합니다.</li>
        <li>서비스는 한국시간 기준 명시된 영업시간 내에서 제공을 원칙으로 합니다. 단, 회사는 제13조[서비스의 변경 및 중단] 사유가 발생한 경우 각 서비스 별로 제공일정 및 제공방법을 변경하거나 서비스를 제공하지 아니할 수 있습니다.</li>
        <li>회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스 제공화면에 공시한 바에 따릅니다.</li>
        <li>개인정보 제공 관련 안내</li>
        <p>본 서비스는 개인정보처리방침에 명시된 바와 같이 결제 및 서비스 운영을 위해 제3자(토스페이먼츠)와 개인정보를 공유할 수 있습니다. 자세한 내용은 개인정보처리방침을 참조하시기 바랍니다. (이용자는 서비스를 사용함으로써 개인정보처리방침에 동의함을 표시합니다.)</p>
      </ol>
    </section>

    <a href="/privacy-policy" title="privacy policy" aria-label="Privacy Policy Page">[개인정보처리방침 바로가기]</a><br/>

    <section id="13" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 13조 [서비스의 변경 및 중단]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 다음 각 호의 1에 해당하는 사유가 발생하는 경우 서비스의 전부 또는 일부를 제한, 변경 또는 중단할 수 있습니다.</li>
          <p>① 이용량 감소로 인한 효율이나 수익성 악화의 경우</p>
          <p>② 이용량 폭주로 인해 원활한 서비스 제공에 지장이 있는 경우</p>
          <p>③ 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우</p>
          <p>④ 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중단했을 경우</p>
          <p>⑤ 기술 진보 등에 따른 새로운 서비스로의 전환 필요성</p>
          <p>⑥ 제휴업체와의 계약종료 등과 같은 회사의 제반사정으로 서비스를 유지할 수 없는 경우</p>
          <p>⑦ 관련 법령의 해석상 서비스의 전부나 일부를 이행하는 것이 위법의 요소가 있는 경우</p>
          <p>⑧ 정전, 천재지변, 국가비상사태, 법령의 재개정, 법원의 판결, 행정기관의 처분, 명령 등으로 서비스 제공에 지장이 있는 경우</p>
          <p>⑨ 회원이 서비스 운영을 고의 또는 중과실로 방해하는 경우</p>
          <p>⑩ 기타 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우</p>
        <li>회사는 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있거나 서비스의 중단이 있는 경우에는 회원에게 제9조 [회원에 대한 통지]에 정한 방법으로 변경 및 중단 사유, 변경되는 서비스의 내용과 제공일자 등을 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</li>
        <li>회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경하는 경우와 관련하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.</li>
      </ol>
    </section>

    <section id="14" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 14조 [서비스 유료/무료 서비스의 제공 및 이용]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 회원에게 다음과 같은 유료 서비스를 제공하며 서비스 제공 목적에 따라 변경되는 유료서비스 항목은 서비스 화면에 게시함으로써 추가, 변경될 수 있습니다.</li>
          <p>① 교신 및 데이터 수집을 위한 안테나 사용료 </p>
        <li>유료 서비스의 상세 내역과 가격정책은 회사의 서비스 소개서, 서비스 카탈로그, 혹은 서비스 요율표 등에 고지된 정책에 따르며, 회원의 요청에 따라 메일, 서비스에 게재 등의 방식으로 제공됩니다.</li>
        <li>유료 서비스 이용계약은 회원이 서비스상에서 다음 각 호 또는 회사가 정하는 이와 유사한 방법에 의하여 유료 서비스를 신청하고, 회사가 이를 승낙함으로써 성립합니다. 회사는 회원이 유료 서비스를 신청함에 있어서 다음 각 호의 내용을 알기 쉽게 제공하여야 합니다.</li>
          <p>① 회사가 제공하는 유료 서비스에 대한 정보</p>
          <p>② 유료 서비스에 관한 약관내용, 청약 철회권이 제한되는 유료 서비스 등에 대한 확인</p>
          <p>③ 이 약관에 동의하고 위 2호의 사항을 확인하거나 거부하는 표시(예: 마우스 클릭)</p>
          <p>④ 선택한 유료 서비스의 확인에 대한 동의</p>
          <p>⑤ 이메일을 통한 결제수단(계좌이체) 방법 송부</p>
        <li>유료 서비스 이용계약은 해당 서비스에 따른 이용요금의 지급이 확인된 시점에 이용계약이 성립합니다.</li>
        <li>민법상 미성년자 또는 피성년후견인인 회원이 유료 서비스를 이용하는 경우, 결제 전 법정대리인 또는 (성년)후견인의 동의를 받아야 하며, 그렇지 않았을 경우 본인 또는 법정대리인(또는 (성년)후견인)은 이를 취소할 수 있습니다.</li>
        <li>회사는 제2항의 유료 서비스 이용계약 신청이 다음 각 호의 어느 하나에 해당하는 경우, 이에 대한 승낙을 하지 아니하거나, 해당 사유가 해소될 때까지 그 승낙을 유보할 수 있습니다. </li>
          <p>① 신청내용에 허위, 기재누락 및 오기가 있는 경우</p>
          <p>② 기타 이용계약 신청을 승낙하는 것이 회사 기술상 현저히 지장이 있거나 법령에 위반된다고 판단되는 경우</p>
        <li>회사는 회원에게 다음과 같은 경우 무료 서비스를 제공합니다.</li>
          <p>① 회사가 서비스를 무료로 제공하고자 하는 경우</p>
      </ol>
    </section>

    <section id="15" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 15조 [유료 서비스 이용계약의 청약철회 및 해지]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 이용 승낙일로부터 7일 이내(이하 ‘청약철회기간’이라 함)에 회사에 청약철회를 요청할 수 있습니다. 다만 7일 이내에 스케줄을 예약했을 경우 취소 불가합니다.  다만, 회원이 청약철회기간 중에 제12조 제1항의 서비스를 이용하거나, 서비스를 통해 제공되는 콘텐츠를 다운로드한 경우에는 청약철회가 불가능하며, 회사는 회원이 쉽게 알 수 있는 곳에 이를 명확하게 적시하는 등의 방법으로 청약철회 등의 권리 행사가 방해받지 아니하도록 조치하여야 합니다.</li>
        <li>회원이 청약철회기간이 경과하거나, 청약철회가 불가능하다고 확정된 이후에는 주문취소 또는 환불이 되지 않으며 청약철회가 불가능한 경우는 다음과 같습니다.</li>  
          <p>① 교신 프로필을 오기재하여 안테나 교신 시도 시 정상 교신이 되지 않는 경우 </p>
          <p>② 스케줄링에 따라 교신 후 아이옵스 스페이스가 제공하는 데이터를 전송받은 경우</p>
        <li>회원은 제1항의 청약철회 및 계약해지를 서비스상에서 직접 요청하거나 또는 iopsspace@i-ops.co.kr로 이메일을 보내어 요청할 수 있습니다.</li>
        <li>회사는 환급을 처리하기 위해 회원에게서 제공받은 정보를 통해 회원에게 연락할 수 있으며, 필요한 정보의 제공을 요청할 수 있습니다.</li>
        <li>회사는 회원으로부터 특별한 사정이 없는 한 청약철회 또는 계약해지 요청을 받은 날로부터 3영업일 이내(이하 ‘환급기간’이라 함)에 회원이 환급받을 금액에 대하여 고지하고 환불 요청 후 약 2주 이내에 회원이 전달한 입금 희망 계좌로 환불됩니다. 회원이 환불을 요청했을 때 회사는 본인 인증 및 환불 계좌 관련 자료를 요구할 수 있으며 회원은 이에 협조해야 합니다. 또한, 회원이 회사가 요청한 환급에 필요한 정보의 제공 등을 지연함으로 인해 소요된 기간은 위 환급기간에서 제외됩니다.</li>
        <li>회원이 납부한 이용요금의 과납 또는 오납이 있을 경우에는, 제5항의 규정을 준용하여 이를 전액 환급합니다. 다만, 해당 과오납금이 회사의 고의 또는 과실 없이 회원의 과실로 인하여 발생한 경우에는 그 환급에 소요되는 비용은 회원이 부담합니다.</li>
      </ol>
    </section>

    <section id="16" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 16조 [정보 제공 및 광고 게재]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 서비스를 운영함에 있어 필요하다고 인정되는 다양한 정보나 광고 등을 서비스 화면에 게재하거나 이메일 등을 이용하여 회원에게 제공할 수 있습니다. 다만, 회원은 관련 법령에 따른 거래 관련 정보, 고객센터 답변 등을 제외한 정보의 전송에 대하여 언제든지 이메일 등을 통하여 수신거절의 의사표시를 할 수 있습니다.</li>
        <li>회사는 서비스 등을 유지하기 위하여 서비스 이용 시 노출되는 공간 또는 타 광고 사업자가 운영하는 매체에 광고를 게재할 수 있으며, 회원은 이로 인한 광고게재에 대하여 동의합니다.</li>  
        <li>회사가 제공하는, 제3자가 주체인, 제2항의 광고에 회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다.</li>
        <li>회사는 적법하게 수집한 회원의 개인정보를 활용하여 제2항의 광고 등을 제공하는 경우 메일주소 등을 활용하여 발송할 수 있으며, 회원이 원하지 않는 경우에는 언제든지 이에 대한 수신을 거부할 수 있습니다.</li>
        <li>회사는 상기 정보제공과 광고와 관련해서는 정보를 회사에 제공하는 플랫폼사업자의 약관 및 회사의 약관에 준거하며 관련 법령 및 시행령의 규정을 준수합니다.</li>
      </ol>
    </section>

    <section id="17" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 17조 [게시물의 저작권]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원이 서비스내에 게시한 게시물의 저작권은 저작권법에 의해 보호를 받으며, 회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
        <li>회원은 자신이 서비스내에 게시한 게시물을 회사가 국내ㆍ외에서 다음 각 호의 목적으로 사용하는 것을 허락합니다.</li>
          <p>① 서비스(제3자가 운영하는 사이트 또는 미디어의 일정 영역내에 입점하여 서비스가 제공되는 경우 포함)내에서 게시물을 사용하기 위하여 게시물의 크기를 변환하거나 단순화하는 등의 방식으로 수정하는 것</p>
          <p>② 회사에서 운영하는 다른 사이트에 게시물을 복제ㆍ전송ㆍ전시하는 것. 다만, 회원이 게시물의 복제ㆍ전송ㆍ전시에 동의하지 아니할 경우에는 그러하지 않습니다.</p>
          <p>③ 회사의 서비스를 홍보하기 위한 목적으로 미디어, 통신사 등에게 게시물의 내용을 보도, 방영하게 하는 것. 단, 이 경우 회사는 회원의 개별 동의없이 미디어, 통신사 등에게 게시물 또는 회원정보를 제공하지 않습니다.</p>
        <li>기타 전항의 목적 외에 회사가 회원의 게시물을 이용하고자 하는 경우에는 사전에 이메일 등의 방법으로 회원의 동의를 얻어야 합니다.</li>
        <li>회원이 서비스에 게시물을 게재하는 것은 다른 회원이 게시물을 서비스내에서 사용하거나 회사가 검색결과로 사용하는 것을 허락한 것으로 봅니다. 다만, 회원은 고객센터를 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 요청할 수 있습니다.</li>
      </ol>
    </section>

    <section id="18" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 18조 [게시물의 관리]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원의 게시물이 정보통신망 이용촉진 및 정보보호에 관한 법률, 저작권법, 개인정보호법, 위치정보의 보호 및 이용 등에 관한 법률 등 관련 법령에 위반되는 내용을 포함하는 경우, 해당 게시물의 권리자는 관련 법령이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사와 회원은 관련 법령에 따른 조치를 취하여야 합니다.</li>
        <li>회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 사회미풍양속, 기타 회사 정책 및 관련 법령에 위반된다고 판단하는 경우에는 관련 법령에 따라 해당 게시물에 대해 삭제나 열람금지 등의 임시 조치 등을 취할 수 있습니다.</li>
        <li>본 조에 따른 세부절차는 &quot;정보통신망법&quot;,  &quot;저작권법&quot; 등 관련 법령이 규정한 범위 내에서 회사가 정한 방침에 따릅니다.</li>
      </ol>
    </section>

    <section id="19" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 19조 [권리의 귀속]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</li>
        <li>회사는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</li>
      </ol>
    </section>

    <section id="20" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 20조 [회원의 지위 승계]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원의 지위를 승계 받고자 하는 승계인이 승계를 요청한 경우로서, 회원인 법인의 합병, 분할, 영업양수·도, 기타 이와 유사한 사유로 인하여 위 승계인이 회원의 지위를 승계하는 것에 회사가 동의한 경우에는, 회사에서 정한 승계 절차에 따라 승계가 가능합니다.</li>
        <li>제1항의 승계 절차는 다음 각 호의 사항을 모두 포함합니다.</li>
          <p>① 승계 이전과 변경된 사항으로 본 서비스와 관련 있는 모든 정보를, 승계 사유가 발생하기 전 또는 예측하기 어려운 경우에는 승계 사유가 발생한 직후 즉시 승계인이 회사에 통보함</p>
          <p>② 승계인 또는 승계인이 지정한 승계인의 피용자에게 회사가 제공하는 서비스가 도달하는 것을 회사가 확인함</p>
        <li>회원의 지위 승계의 사유가 발생한 경우 회원이 회사에 승계 사실을 제때 통지하지 않아 발생하는 문제에 대하여 회사는 일체의 책임을 지지 않습니다.</li>
        <li>승계 사실이 회사에 통지되지 않은 경우, 또는 회사가 승계인의 승계 요청에 동의하지 않거나 승계인이 제1항 및 제2항의 승계 절차를 이행하지 않은 경우, 유료 서비스의 이용요금 지급 등 이 약관에 규정된 의무는 여전히 승계인이 아닌 회원에게 있습니다.</li>
        <li>승계인이 제공한 정보에 오류가 있는 경우 발생하는 문제에 대하여 회사는 일체의 책임을 지지 않습니다.</li>
      </ol>
    </section>

    <section id="21" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 21조 [이용계약 해지 등]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 언제든지 서비스 내 설정 메뉴를 통하여 회원 탈퇴 신청을 하는 방법으로 이용계약을 해지할 수 있으며, 회사는 관련 법령과 내부기준이 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li>
        <li>회원이 이용계약을 해지하는 경우 관련법 및 개인정보취급방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.</li>
        <li>회원이 이용계약을 해지하는 경우 본인 계정에 등록한 게시물 일체는 삭제됩니다. 다만, 회원이 서비스 이용 중 다른 회원에게 제공(또는 공유)한 콘텐츠의 경우 다른 회원이 보유하는 콘텐츠는 소멸되지 않습니다.</li>
      </ol>
    </section>

    <section id="22" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 22조 [이용제한 등]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시이용정지, 이용계약해지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</li>
        <li>회사는 전항에도 불구하고, &quot;주민등록법&quot;을 위반한 명의도용 및 결제도용, &quot;저작권법&quot; 및 &quot;컴퓨터프로그램보호법&quot;을 위반한 불법프로그램의 제공 및 운영방해, &quot;정보통신망법&quot;을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 서비스 이용을 통해 획득한 포인트 및 기타 혜택 등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.</li>
        <li>회사는 회원이 계속해서 3개월 이상 로그인하지 않는 경우, 회원정보의 보호 및 운영의 효율성을 위해 이용을 제한할 수 있습니다.</li>
        <li>회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 서비스상의 운영정책에서 정하는 바에 의합니다.</li>
        <li>본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 회사는 제9조[회원에 대한 통지]에 따라 통지합니다. 다만, &quot;회사&quot;가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</li>
        <li>회원은 본 조에 따른 이용제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</li>
        <li>&quot;회사&quot;는 전 항에도 불구하고, &quot;주민등록법&quot;을 위반한 명의도용 및 결제도용등의 피해신고가 접수되거나, 공공 및 금융기관을 통해 감지된 경우 관계법령의 준수를 위하여 이용을 제한할 수 있습니다.</li>
      </ol>
    </section>

    <section id="23" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 23조 [손해배상]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 유료 서비스 이용이 불가하거나 이용에 장애가 있는 경우, 회사는 유료 서비스를 이용중인 회원에게 그 손해를 배상합니다. 다만, 회사의 고의 또는 과실 없이 회원에게 발생한 손해에 대하여는 책임을 지지 아니합니다. 회사는 해당 회원에게 손해를 배상하는 경우, 그 방식과 절차 등에 관해 콘텐츠이용자보호`지침의 관련 규정 및 기타 상관례를 따릅니다.</li>
        <li>제1항에도 불구하고, 회원이 이용 불가 또는 이용 장애의 사실을 회사에 접수한 이후 72시간 이내에 정상화된 경우, 회사는 이에 대한 책임을 지지 않습니다.</li>
        <li>회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.</li>
        <li>회원이 서비스를 이용하는 과정에서 행한 불법행위나 이 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상할 책임이 있습니다.</li>
      </ol>
    </section>

    <section id="24" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 24조 [책임제한]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
        <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
        <li>회사는 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다. </li>
        <li>회사는 회원 간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</li>
        <li>회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다. </li>
        <li>회사는 제3자가 서비스 내 화면 또는 링크된 웹사이트를 통하여 광고한 제품 또는 서비스의 내용과 품질에 대하여 감시할 의무 기타 어떠한 책임도 지지 아니합니다.</li>
        <li>회사 및 회사의 임직원 그리고 대리인은 다음과 같은 사항으로부터 발생하는 손해에 대해 책임을 지지 아니합니다.</li>
          <p>① 회원 상태정보의 허위 또는 부정확성에 기인하는 손해</p>
          <p>② 그 성질과 경위를 불문하고 서비스에 대한 접속 및 서비스의 이용과정에서 발생하는 개인적인 손해</p>
          <p>③ 서버에 대한 제3자의 모든 불법적인 접속 또는 서버의 불법적인 이용으로부터 발생하는 손해</p>
          <p>④ 서버에 대한 전송 또는 서버로부터의 전송에 대한 제3자의 모든 불법적인 방해 또는 중단행위로부터 발생하는 손해</p>
          <p>⑤ 제3자가 서비스를 이용하여 불법적으로 전송,유포하거나 또는 전송,유포되도록 한 모든 바이러스, 스파이웨어 및 기타 악성 프로그램으로 인한 손해</p>
          <p>⑥ 전송된 데이터의 오류 및 생략, 누락, 파괴 등으로 발생되는 손해</p>
          <p>⑦ 회원간의 회원 상태정보 등록 및 서비스 이용 과정에서 발생하는 명예훼손 기타 불법행위로 인한 각종 민형사상 책임</p>
      </ol>
    </section>

    <section id="25" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 25조 [해외이용]</h2>
      <p>회사는 전세계 모든 국가에서의 서비스의 동일한 품질 또는 사용성을 보장하지 않습니다. 따라서 회원은 서비스를 이용하고자 하는 경우 스스로의 판단과 책임에 따라서 이용 여부를 결정하여야 하고, 특히 서비스의 이용과정에서 현지 법령을 준수할 책임은 회원에게 있습니다.</p>
    </section>

    <section id="26" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">제 26조 [준거법 및 재판관할]</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사와 회원간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
        <li>회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법 상의 서울중앙지방법원을 전속적 관할로 제소합니다.</li>
      </ol>
    </section>

    <section id="Addendum" className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">부칙</h2>
      <ol className="list-decimal pl-5 space-y-2">
        <li>이 약관은 2025년 1월 0일부터 적용됩니다.</li>
      </ol>
    </section>

    <section className="mb-8">
      <p><b>주식회사 아이옵스는 여러분이 쉽게 알 수 있도록 약관 및 운영정책을 게시하며 사전 공지 후 개정합니다.</b><br/>
      주식회사 아이옵스는 본 약관의 내용을 여러분이 쉽게 확인할 수 있도록 서비스 초기 화면에 게시하고 있습니다.<br/>
      주식회사 아이옵스는 수시로 본 약관, 계정 및 게시물 운영정책을 개정할 수 있습니다만, 관련 법령을 위배하지 않는 범위 내에서 개정할 것이며, 사전에 그 개정 이유와 적용 일자를 서비스 내에 알리도록 하겠습니다. 또한 여러분에게 불리할 수 있는 중대한 내용의 약관 변경의 경우에는 최소 30일 이전에 해당 서비스 내 공지하고 별도의 전자적 수단(전자메일, 서비스 내 알림 등)을 통해 개별적으로 알릴 것입니다.<br/>
      주식회사 아이옵스는 변경된 약관을 게시한 날로부터 효력이 발생되는 날까지 약관 변경에 대한 여러분의 의견을 기다립니다. 위 기간이 지나도록 여러분의 의견이 주식회사 아이옵스에 접수되지 않으면, 여러분이 변경된 약관에 따라 서비스를 이용하는 데에 동의하는 것으로 간주됩니다. 주식회사 아이옵스로서는 매우 안타까운 일이지만, 여러분이 변경된 약관에 동의하지 않는 경우 변경된 약관의 적용을 받는 해당 서비스의 제공이 더 이상 불가능하게 될 수 있습니다.<br/>
      아이옵스 스페이스 서비스에는 기본적으로 본 약관이 적용됩니다만, 부득이 각 개별 서비스의 고유한 특성을 반영하기 위해 본 약관 외 별도의 약관, 운영정책이 추가로 적용될 때가 있습니다. 따라서 별도의 약관, 운영정책에서 그 개별 서비스 제공에 관하여 본 약관, 계정 및 게시물 운영정책과 다르게 정한 경우에는 별도의 약관, 운영정책이 우선하여 적용됩니다. 이러한 내용은 각각의 개별 서비스 초기 화면에서 확인해 주시기 바랍니다.<br/>
      본 약관은 한국어를 정본으로 합니다. 본 약관 또는 아이옵스 스페이스 서비스와 관련된 여러분과 주식회사 아이옵스와의 관계에는 대한민국의 법령이 적용됩니다. 그리고 본 약관 또는 주식회사 아이옵스 서비스와 관련하여 여러분과 주식회사 아이옵스 사이에 분쟁이 발생할 경우, 그 분쟁의 처리는 대한민국 &apos;민사소송법&apos;에서 정한 절차를 따릅니다.<br/>
      </p>
    </section>

    <footer className="mt-12 pt-4 border-t border-gray-300 text-sm text-gray-600">
      <p>공지 일자: 2024년 1월 0일</p>
      <p>적용 일자: 2024년 1월 0일</p>
      <p>아이옵스 스페이스 서비스와 관련하여 궁금하신 사항이 있으시면 (대표번호: 042-322-7609/ 평일 09:00~18:00)로 문의 주시기 바랍니다.</p>
    </footer>
  </div>
  );
};

export default TermsOfUsePopup;

